export function BadgeSoon({ children = "Em breve" }) {
  return (
    <span
      data-testid="badge-em-breve"
      className="inline-flex items-center gap-1.5 rounded-full border border-amber-300 bg-amber-100 px-3 py-1 text-[11px] font-bold uppercase tracking-wider text-amber-800"
    >
      {children}
    </span>
  );
}

export function BadgeLive({ children = "Disponível no lançamento" }) {
  return (
    <span
      data-testid="badge-disponivel"
      className="inline-flex items-center gap-1.5 rounded-full border border-emerald-300 bg-emerald-50 px-3 py-1 text-[11px] font-bold uppercase tracking-wider text-emerald-700"
    >
      <span className="h-1.5 w-1.5 rounded-full bg-emerald-500" />
      {children}
    </span>
  );
}

export function SectionHead({ eyebrow, title, lead, dark = false, center = false }) {
  return (
    <div className={`max-w-2xl ${center ? "mx-auto text-center" : ""}`}>
      {eyebrow && (
        <p className="font-mono text-xs font-semibold uppercase tracking-[0.3em] text-brand-orange">
          {eyebrow}
        </p>
      )}
      <h2
        className={`mt-3 font-display text-2xl font-extrabold tracking-tight sm:text-3xl lg:text-4xl ${
          dark ? "text-white" : "text-slate-900"
        }`}
        data-testid="section-title"
      >
        {title}
      </h2>
      {lead && (
        <p className={`mt-4 text-base leading-relaxed sm:text-lg ${dark ? "text-slate-300" : "text-slate-600"}`}>
          {lead}
        </p>
      )}
    </div>
  );
}

export function BtnOrange({ as: Tag = "button", className = "", children, ...props }) {
  const cls = `inline-flex items-center justify-center gap-2 rounded-full bg-brand-orange px-7 py-3.5 text-sm font-bold text-white shadow-lg shadow-brand-orange/25 transition-all duration-300 hover:-translate-y-0.5 hover:bg-brand-orangedark hover:shadow-xl hover:shadow-brand-orange/30 disabled:cursor-not-allowed disabled:opacity-60 ${className}`;
  return (
    <Tag className={cls} {...props}>
      {children}
    </Tag>
  );
}

export function BtnGhost({ as: Tag = "button", dark = true, className = "", children, ...props }) {
  const cls = `inline-flex items-center justify-center gap-2 rounded-full border px-7 py-3.5 text-sm font-bold transition-all duration-300 hover:-translate-y-0.5 ${
    dark
      ? "border-white/25 text-white hover:border-brand-orange hover:text-brand-orange"
      : "border-slate-300 text-slate-800 hover:border-brand-orange hover:text-brand-orange"
  } ${className}`;
  return (
    <Tag className={cls} {...props}>
      {children}
    </Tag>
  );
}
